<template>
  <div class="navbar_container">
    <div class="left">
      <slot name="logo"></slot>
    </div>
    <div class="center" v-if="$slots.title">
      <slot name="title"></slot>
    </div>
    <div class="right">
      <slot name="globalSelect"></slot>
      <div class="fullscreen" @click="toggle">
        <slot name="fullscreen" :scope="{ isFullscreen }"></slot>
      </div>
      <div v-if="displayClock&&systemTime" class="navbar-clock">
        {{ currenntDate }} <span class="navbar-clock__time">{{ currentTime }}</span>
      </div>
      <slot></slot>
      <el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
        <span class="el-dropdown-link navbar-bg-hover select-none">
          <img :src="userAvatar" :style="avatarsStyle" />
          <span v-if="username" class="dark:text-white">{{ username }}</span>
          <el-icon>
            <caret-bottom />
          </el-icon>
        </span>
        <!-- <div class="avatar-wrapper">
          <span v-if="username" class="user-name">{{ username }}</span>
        </div> -->
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <router-link to="/user/profile">
              <el-dropdown-item>个人中心</el-dropdown-item>
            </router-link>-->
            <el-dropdown-item command="password">
              <span>修改密码</span>
            </el-dropdown-item>
            <!-- <el-dropdown-item command="logo">
              <span>LOGO设置</span>
            </el-dropdown-item> -->
            <!-- divided -->
            <el-dropdown-item command="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, useSlots, onUnmounted, getCurrentInstance } from "vue";
import { useFullscreen } from "@vueuse/core";
import userAvatar from "./user.png";
import dayjs from 'dayjs'

import {emitter} from "@/utils/mitt";

const { isFullscreen, toggle } = useFullscreen();
const {proxy} = getCurrentInstance()
const $slots = useSlots()
const props = defineProps({
  logout: {
    type: Function,
    default: () => { },
  },
  setting: {
    type: Function,
    default: () => { },
  },
  username: {
    type: String,
  },
  displayClock: {
    type: Boolean,
    default: false,
  }
});
const avatarsStyle = computed(() => {
  return props.username ? { marginRight: "10px" } : "";
});
function handleCommand(command) {
  switch (command) {
    case "password":
      props.setting("PASSWORD");
      break;
    case "logo":
      props.setting("LOGO");
      break;
    case "logout":
      beforeLogOut();
      break;
    default:
      break;
  }
}

function beforeLogOut() {
  proxy.$confirm("确定要退出吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      props.logout();
    })
    .catch(() => {
      console.log('cancel');
    })
}


let t
let currenntDate = dayjs().format('YYYY年MM月DD日')
const currentTime = ref('');

const systemTime = ref(false);
const date = ref(dayjs());
setTimeout(() => {
  (function refreshCurrentTime() {
    if(systemTime.value){
      date.value  = date.value.add(1, 'second');
      currentTime.value = dayjs(date.value).format('HH:mm:ss');
      currenntDate = dayjs(date.value).format('YYYY年MM月DD日');
    }else{
      currentTime.value = dayjs().format('HH:mm:ss')
    }
    t = setTimeout(refreshCurrentTime, 1000)
  })();
}, 200);

emitter.on('timeSync', (data) => {
  systemTime.value = !!data;
  date.value = dayjs(data)
});

onUnmounted(() => {
  clearTimeout(t)
})


</script>
<style lang="scss" scoped>


.navbar_container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1D2129;


  .left {
    color: #fff;
    height: 100%;
  }

  .center {
    flex: 1;
    flex-wrap: wrap;
    justify-content: center;
    align-self: stretch;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }

  .right {
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 15px;

    .fullscreen {
      margin-right: 10px;
      cursor: pointer;
    }

    .el-dropdown {
      color: #fff;
      height: 100%;
    }

    .el-dropdown-link {


      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 10px;
      cursor: pointer;
      color: #fff;
      &:hover {
        background: #4091f7;
      }
      p {
        font-size: 14px;
      }

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
  }

  .navbar-clock {
    color: #aeb4be;
    display: flex;
    align-items: center;
    min-width: 210px;

    .navbar-clock__time {
      font-family: 'DS-Digital';
      color: orange;
      // font-weight: bold;
      font-size: 24px;
      margin-left: 2px;
      position: relative;
      top: -1px;
    }

  }
}
</style>
